/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_SubtitleInputs */

const en_tts_tool_subtitle = /** @type {(inputs: Tts_Tool_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste text, choose a voice, and generate a 24-hour read-along link.`)
};

const es_tts_tool_subtitle = /** @type {(inputs: Tts_Tool_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un texto, elige una voz y genera un enlace de lectura y audio por 24 horas.`)
};

/**
* | output |
* | --- |
* | "Paste text, choose a voice, and generate a 24-hour read-along link." |
*
* @param {Tts_Tool_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_subtitle = /** @type {((inputs?: Tts_Tool_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_subtitle(inputs)
	return en_tts_tool_subtitle(inputs)
});